export var MessageActionKind;
(function (MessageActionKind) {
    MessageActionKind["SET_ERROR"] = "SET_ERROR";
    MessageActionKind["SET_CONTENT"] = "SET_CONTENT";
    MessageActionKind["UPDATE_PROGRESS"] = "UPDATE_PROGRESS";
    MessageActionKind["CLEAR"] = "CLEAR";
})(MessageActionKind || (MessageActionKind = {}));
